import { name } from './constants';
import reducer from './reducer';
import ApprovalRequests from './ApprovalRequests';

export default {
  name,
  ApprovalRequests,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/approvalRequests/index.js